module.exports = __webpack_public_path__ + "static/media/icon_facebook.e8f7398e.svg";